// extracted by mini-css-extract-plugin
export default {"list":"Item_list__HuTQY","list__icon":"Item_list__icon__wQmwc","list__name":"Item_list__name__Ekdja"};